// Libs
import { Grid2 } from '@mui/material';
import classNames from 'classnames/bind';
import { Outlet } from 'react-router-dom';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './Public.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const Public = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2 id='publicLayout' container className={cx('container')}>
      <Outlet />
    </Grid2>
  );
};

export default Public;
